import { ThunkAction } from "redux-thunk";

import { trackEvent } from "helpers/analytics";
import { selectCategoriesWithRoles } from "store/select/scheduling";
import { ICategoryWithRoles } from "helpers/schedule/action_bar/filters";
import { IRootStateProps } from "types/reducers";

export type FilterActionTypes =
  | IClearFiltersAction
  | IToggleCategoryAction
  | IToggleRoleAction;

type FilterThunkResult<R> = ThunkAction<
  R,
  IRootStateProps,
  undefined,
  FilterActionTypes
>;

export enum FilterTypeKeys {
  CLEAR_FILTERS = "filters/CLEAR_FILTERS",
  TOGGLE_ROLE = "filters/TOGGLE_ROLE",
  TOGGLE_CATEGORY = "filters/TOGGLE_CATEGORY",
  TOGGLE_ALL_CATEGORIES = "filters/TOGGLE_ALL_CATEGORIES",
}

export interface IToggleCategoryAction {
  type: FilterTypeKeys.TOGGLE_CATEGORY;
  allCategoriesWithRoles: ICategoryWithRoles[];
  category: string;
}

function toggleCategory(category: string): FilterThunkResult<void> {
  return (dispatch, getState) => {
    trackEvent("toggle category filter", { category });
    const allCategoriesWithRoles = selectCategoriesWithRoles(getState());
    dispatch({
      type: FilterTypeKeys.TOGGLE_CATEGORY,
      allCategoriesWithRoles,
      category,
    });
  };
}

export interface IToggleRoleAction {
  type: FilterTypeKeys.TOGGLE_ROLE;
  role: string;
}

function toggleRole(role: string): FilterThunkResult<void> {
  return (dispatch) => {
    trackEvent("toggle role filter", { role });
    dispatch({
      type: FilterTypeKeys.TOGGLE_ROLE,
      role,
    });
  };
}

interface IClearFiltersAction {
  type: FilterTypeKeys.CLEAR_FILTERS;
}

function clearFilters(): IClearFiltersAction {
  trackEvent("clear filters");
  return {
    type: FilterTypeKeys.CLEAR_FILTERS,
  };
}

export { clearFilters, toggleRole, toggleCategory };
